import {tgxApi} from "../../../app/tgxApi";
import {
    getAuthorizationHeader, getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";


export const parentAccountApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        getAllParentAccountById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/parent-account/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['parentAccount'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getParentAccountById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-parent-account-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['parentAccount'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createParentAccountBySubdivisionId: build.mutation({
            query: ({requestBody,id}) => {
                return {
                    url: `/ajax/create-parent-account/${id}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['subDivisionById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Parent Account")
            },
        }),
        updateParentAccount: build.mutation({
            query: ({id, requestBody}) => {
                return {
                    url: `/ajax/update-parent-account/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['subDivisionById',],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Sub Division")
            },
        }),
        deleteParentAccountById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete-parent-account/${id}`,
                    method: 'POST',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['subDivisionById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Parent Account");
            },
        }),

    }),
});

export const {useCreateParentAccountBySubdivisionIdMutation,
useDeleteParentAccountByIdMutation,
useGetAllParentAccountByIdQuery,
useGetParentAccountByIdQuery,
useUpdateParentAccountMutation}=parentAccountApi